import { useEffect } from 'react';

import type { ResourceTypeHandle } from '@toolproof-core/genesis/_contract/_index';
import type { CosmosData } from '@toolproof-core/visualization/derivation/_contract/derivation';

import type { SpaceAdapterDescriptor } from '@/_contract/types';

export function useAdapterRuntimeEffects<
	TResourceTypeHandle extends ResourceTypeHandle,
	TCosmosData extends CosmosData<TResourceTypeHandle>,
	TConfig,
	TRuntimeState,
>(args: {
	owner: ReturnType<NonNullable<SpaceAdapterDescriptor<TResourceTypeHandle, TCosmosData, TConfig, TRuntimeState>['createRuntimeEffectOwner']>> | undefined;
	config: TConfig;
	runtimeState: TRuntimeState;
	cosmosData: TCosmosData;
	playbackActive: boolean;
	animationSuspended: boolean;
	loading: boolean;
	routeError: string | undefined;
}) {
	const { owner, config, runtimeState, cosmosData, playbackActive, animationSuspended, loading, routeError } = args;
	useEffect(() => {
		if (loading || routeError) return;
		owner?.({ config, runtimeState, cosmosData, playbackActive, animationSuspended });
	}, [owner, config, runtimeState, cosmosData, playbackActive, animationSuspended, loading, routeError]);
	useEffect(() => () => owner?.dispose?.(), [owner]);
}
